import React from 'react'
import { Button } from '../../../../../components/Button/Button'
import { Modal } from '../../../../../components/Modal/Modal'

type SmartOfficeAlreadyConnectedModalProps = {
  show: boolean
  onClose: () => void
  onConnectAnyway: () => void
}

export const SmartOfficeAlreadyConnectedModal: React.FC<SmartOfficeAlreadyConnectedModalProps> = ({ show, onClose, onConnectAnyway }) => {
  const body = (
    <div className='text-center p-4'>
      <h5 className='mb-3'>You already have a SmartOffice integration.</h5>
    </div>
  )

  const footer = (
    <div className='d-flex justify-content-center gap-3'>
      <Button variant='secondary' onClick={onClose}>
        Close
      </Button>
      <Button variant='primary' onClick={onConnectAnyway}>
        Connect Anyway
      </Button>
    </div>
  )

  return <Modal show={show} onHide={onClose} header={<></>} body={body} footer={footer} centered />
}
